<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>Details</mat-card-title>
        <div class="site-details-tools" tabindex="-1">
            <mat-icon 
                      [ngClass]="{'btn-disabled':!site.siteIsBuildable}"
                      title="Edit Site Details"
                      aria-label="Edit site details"
                      (click)="onEditClick($event)"
                      tabindex="0"
                      (keyup.enter)="onEditClick($event)">edit</mat-icon>
            <mat-icon *ngIf="closable"
                      class="site-details-close-btn"
                      title="Close the Details Pane"
                      aria-label="Close the Details Pane"
                      (click)="onClose()"
                      tabindex="0"
                      (keyup.enter)="onClose()">close</mat-icon>
        </div>
    </mat-card-header>
    <mat-card-content>
        <div class="siteName">{{site.name}}</div>
        <div class="siteDesc">{{site.description}}</div>
        <div class="row">
            <div class="label">BDR/Memo Number and Title:</div><div class="col-md-6 value">{{site.purpose}}</div>
        </div>
        <div class="row">
            <div class="label">Frequency:</div><div class="col-md-6 value">{{site.frequency}}</div>
        </div>
        <div class="row">
            <div class="label">Contact(s):</div>
            <div class="col-md-6 value"><ng-container *ngIf="site.maxPointOfContact != null">{{site.maxPointOfContactDspl}} - {{site.maxPointOfContactEmail}}</ng-container></div>
        </div>

        <div *ngIf="showActivatedDate() || showClosedDate()"
             class="readonly">
            <div *ngIf="showActivatedDate()">
                <div class="row">
                    <div class="label">Activated:</div><div class="col-md-6 value">{{site.activatedDate | date: 'medium'}}</div>
                </div>
            </div>

            <div *ngIf="showClosedDate()">
                <div class="row">
                    <div class="label">Closed:</div><div class="col-md-6 value">{{site.closedDate | date: 'medium'}}</div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
